import {
  normalizeDisplayMathFences,
  normalizeSingleDollarLatexCommands,
  replaceCopilotInlineTokens,
  withHardBreaks
} from './utils'

export interface MarkdownPreprocessResult {
  markdown: string
}

export interface MarkdownPreprocessOptions {
  /**
   * When true, replace known Copilot inline tokens (e.g. chart) and strip unknown ones.
   * Also removes trailing incomplete tokens while a message is still streaming.
   */
  processCopilotInlineTokens?: boolean
  /**
   * Optional Copilot (or other) table extractor. Returns rewritten markdown.
   * Keep table id maps in the caller; Markdown stays free of Copilot imports.
   */
  extractTables?: (markdown: string) => string
}

/**
 * Pure markdown preprocess pipeline: chart/citation tokens → optional tables → math → hard breaks.
 *
 * Inline tokens must be rewritten before table extraction so `$[[ … ]]$` markers inside
 * GFM cells are stripped (or turned into chart elements) instead of being stored raw on
 * the extracted table and shown in ChartCard.
 */
export const preprocessMarkdownText = (
  children: string,
  { processCopilotInlineTokens = false, extractTables }: MarkdownPreprocessOptions = {}
): MarkdownPreprocessResult => {
  let text = children

  if (processCopilotInlineTokens) {
    text = replaceCopilotInlineTokens(text)
  }

  if (extractTables != null) {
    text = extractTables(text)
  }

  text = normalizeSingleDollarLatexCommands(text)
  text = normalizeDisplayMathFences(text)

  return { markdown: withHardBreaks(text) }
}
